export default __webpack_public_path__ + "static/media/stats_active.75fcde78.svg";